import { ReactElement } from 'react';

import { QueueUploadTiffParam } from './params/QueueUploadTiffParam';
import { QueueGeopostLayerItemActions } from '../geopostLayer/QueueGeopostLayerItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class UploadTiffHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = [];

    renderParams(onParamsChange?: (params: Record<string, unknown>) => void, initialValues?: Record<string, string>): ReactElement {
        return <QueueUploadTiffParam onParamsChange={onParamsChange} initialValues={initialValues} />;
    }

    renderItemActions(_props: IItemActionsProps): ReactElement {
        return <QueueGeopostLayerItemActions />;
    }
}
